// Loaded at runtime from the intl-tel-input utilsScript - may never arrive
declare var intlTelInputUtils: any;

/**
 * The phone number to submit as phoneNumberComplete.
 *
 * DEV-7562: intlTelInputUtils is a global that only exists once the CDN utilsScript has
 * loaded, and intlInstance is undefined when intlTelInput itself failed to load. Reading
 * either unguarded threw on submit, which stopped the lead from being sent at all. When
 * the library is not usable, fall back to what the visitor typed: an unformatted number
 * beats a lost lead.
 */
export function completePhoneNumber( intlInstance: any, rawValue: string | null | undefined ): string {

	if( typeof intlTelInputUtils !== 'undefined' && intlInstance && typeof intlInstance.getNumber === 'function' ) {

		return intlInstance.getNumber( intlTelInputUtils.numberFormat.E164 );
	}

	return ( rawValue ?? '' ).trim();
}

/**
 * Country options for intlTelInput. A missing country (the visitor has not picked one yet,
 * or autofill filled the phone field first) must not reach preferredCountries: the library
 * calls toLowerCase() on every entry and throws on null.
 */
export function intlCountryOptions( countryFrom: string | null | undefined, countryTo: string | null | undefined ): { initialCountry: string, preferredCountries: string[] } {

	const preferred = [countryFrom, countryTo]
		.filter( ( c ): c is string => typeof c === 'string' && c !== '' )
		.map( c => c.toLowerCase() )
		.filter( ( c, i, all ) => all.indexOf( c ) === i );

	return {
		initialCountry: preferred[0] ?? '',
		preferredCountries: preferred,
	};
}
